// ls
import {
  getUserinfoFromLocalStorage,
  setUserinfoToLocalStorage,
  clearUserinfoToLocalStorage,
} from '@shakkerai/util-localstorage';

// cookie
import { getUsertokenFromCookie, clearUsertokenToCookie } from '@shakkerai/util-cookie';

// services
import { getUserInfoByToken } from '@shakkerai/services';

/**
 * getUserinfo
 * @param {*} isForced
 * @returns
 */
export const getUserinfo = async (isForced) => {
  const methodName = 'getUserinfo';
  console.info(methodName, 'isForced', isForced);

  // from localstorage
  const userinfoFromLS = getUserinfoFromLocalStorage();
  if (!isForced && userinfoFromLS) {
    console.info(methodName, 'from ls success');
    return {
      data: userinfoFromLS,
      status: 'done',
    };
  }

  // from cookie
  const usertoken = getUsertokenFromCookie();
  if (!usertoken) {
    console.info(methodName, 'from cookie fail, not login');
    return {
      data: null,
      status: 'done',
    };
  }

  // from services
  const res = await getUserInfoByToken(usertoken);
  if (res.code !== 0 || !res.data) {
    console.error(methodName, 'get userinfo by token fail', res.msg);
    return {
      data: null,
      status: 'done',
    };
  }

  // userinfo
  const userinfo = res.data;
  console.info(methodName, 'from services success');

  // set ls
  setUserinfoToLocalStorage(userinfo);
  return {
    data: userinfo,
    status: 'done',
  };
};

/**
 * clearUserinfo
 * @returns
 */
export const clearUserinfo = () => {
  // ls
  clearUserinfoToLocalStorage();

  // cookie
  clearUsertokenToCookie();
};
